module.exports = __webpack_public_path__ + "img/money-lock.90e0c6e2.png";